import {
	Button,
	Checkbox,
	FormControlLabel,
	MuiThemeProvider,
	TextField,
	createMuiTheme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
	deleteCompetitionType,
	getCompetitionTypeById,
	postCompetitionType,
	updateCompetitionType,
} from "../../../../api/competitionType";
import { checkIsEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { changes, setChanges } from "../../../../utils/globals";

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

function getEmptyCompetitionType() {
	return {
		fullName: {},
		imageURL: null,
		active: true,
	};
}

export default function EditCompetitionTypesPage() {
	const [competitionType, setCompetitionType] = useState(getEmptyCompetitionType());
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

	const competitionTypeId = useParams().id;
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	// const [changes, setChanges] = useState(-2);
	useEffect(() => setChanges(-2), []);
	useEffect(() => {
		if (!competitionTypeId) setChanges(changes+2);
		else setChanges(changes+1);
	}, [competitionType])

	useEffect(() => {
		if (!competitionTypeId) {
			disableLoadingData();
			return;
		}
		getCompetitionTypeById(competitionTypeId)
			.then((res) => {
				if (res.status === 200) {
					setCompetitionType(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get competition type.",
				});
				setChanges(0);
				history.push("/competition-types");
			});
	}, [competitionTypeId, disableLoadingData, history]);

	function saveCompetitionType() {
		if (checkIsEmpty(competitionType.fullName))
			return alertError({
				error: null,
				customMessage:
					"The name is required in at least one of the languages.",
			});
		if (!competitionTypeId) {
			postCompetitionType(competitionType, null)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "Saved!",
							customMessage: "Competition type successfully created.",
						});
						setChanges(0);
						history.push("/competition-types");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save competition type.",
					});
				});
		} else {
			updateCompetitionType(competitionTypeId, competitionType, null)
				.then((res) => {
					if (res.status === 200) {
						alertSuccess({
							title: "Saved!",
							customMessage: "Changes successfully saved.",
						});
						setChanges(0);
						history.push("/competition-types");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save changes.",
					});
				});
		}
	}

	const handleChange = (element, lang) => (event) => {
		if (event.target.value === " ") return;
		if (lang) {
			if (!competitionType[element]) competitionType[element] = {};
			let newText = competitionType[element];
			newText[lang] = event.target.value;
			setCompetitionType({ ...competitionType, [element]: newText });
		} else
			setCompetitionType({
				...competitionType,
				[element]: event.target.value,
			});
	};

	const renderMultilanguageTabContent = (lang) => {
		return (
			<>
				<br />
				<TextField
					id={`fullName`}
					label="Full name"
					value={
						(competitionType.fullName && competitionType.fullName[lang]) || ""
					}
					onChange={handleChange("fullName", lang)}
					InputLabelProps={{
						shrink: true,
					}}
					margin="normal"
					variant="standard"
					required
				/>
			</>
		);
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
				<CardHeader title={competitionType?._id?'Competition type: ' + (competitionType.fullName?competitionType.fullName.es:''):'New competition type'}>
					<div className="mt-5">
						<Button
							onClick={() => {
								if (changes > 0) setOpenConfirmDialog(1);
								else history.push("/competition-types");
							}}
							variant="outlined"
							style={{ marginRight: "20px" }}
						>
							Back
						</Button>
						<Button
							onClick={() => saveCompetitionType()}
							variant="outlined"
							color="primary"
							style={{ marginRight: "20px" }}
						>
							Save competition type
						</Button>
						<ConfirmDialog
							title={
								"Are you sure you want to go back? You will lose all your changes"
							}
							open={openConfirmDialog === 1}
							setOpen={setOpenConfirmDialog}
							onConfirm={() => {
								setChanges(0);
								history.push("/competition-types")
							}}
						/>
						{competitionTypeId && user?.role.includes("admin") && (
							<>
								<MuiThemeProvider theme={theme}>
									<Button
										onClick={() => setOpenConfirmDialog(2)}
										variant="outlined"
										color="secondary"
										style={{ marginRight: "20px" }}
									>
										Delete competition type
									</Button>
									<div
										style={{
											display: "flex",
											flexDirection: "row",
											marginLeft: "auto",
										}}
									></div>
								</MuiThemeProvider>

								<ConfirmDialog
									title={
										"Are you sure you want to delete this competition type?"
									}
									open={openConfirmDialog === 2}
									setOpen={setOpenConfirmDialog}
									onConfirm={() => {
										deleteCompetitionType(competitionTypeId)
											.then((res) => {
												if (
													res.status === 204 ||
													res.status === 200
												) {
													alertSuccess({
														title: "Deleted!",
														customMessage:
															"Competition type deleted successfully",
													});
													setChanges(0);
													history.push("/competition-types");
												}
											})
											.catch((error) => {
												alertError({
													error: error,
													customMessage:
														"Could not delete competition type.",
												});
											});
									}}
								/>
							</>
						)}
					</div>
				</CardHeader>
					<CardBody>
						<MultilanguageTabBlock
							multilanguageTabContent={
								renderMultilanguageTabContent
							}
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={competitionType.active}
									onChange={() =>
										setCompetitionType({
											...competitionType,
											active: !competitionType.active,
										})
									}
									name="checkActive"
								/>
							}
							label="Active"
						/>
					</CardBody>
				</Card>
			</>
		);
}
